module.exports = __webpack_public_path__ + "static/media/hall-sph706-1.1668840d.svg";